
<template>

  <div class="rdg-outer">
    <div class="rdg-half">
      <div class="rdg-half-outer" v-if="rdgOne !== 'iaq'">
        <img v-if="rdgOne !== 'iaq'" :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${rO.img}.png`" />
      </div>
      <div style="justify-content:center;" class="rdg-half-inner" v-if="rdgOne !== 'iaq'">
        <h1 v-if="!dpr || !room.info.coilSensor">{{rO.val}}<span style="font-size:.5em;">{{rO.units}}</span></h1>
        <h5 style="color:rgb(0, 153, 191);margin:6px;" v-else>Calculating...</h5>
        <h4
          style="margin:2px;display:flex;justify-content:center;align-items:center;border-top:1px solid #dce1ec; padding-top:3px;text-align:center;"
          v-if="rdgOne == 'days'">
            <img v-if="!room.info.coilSensor" class="cal-img" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/calendar.png" />
          Next Maint: {{!dpr || !room.info.coilSensor ? setChangeDate() : '-'}}
        </h4>
      </div>
      <div v-else class="rdg-half-inner" style="justify-content:space-around;height:100%;">
          <div class="rdg-quarter">
            <v-popover class="quarter-icon" offset="10" trigger="hover" placement="right">
              <img style="width:32px" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/iaq.png" />
              <small>IAQ<br/>Index</small>
              <template slot="popover">
                  <hover-component :options="hoverOptions('iaq')"></hover-component>
              </template>
            </v-popover>
              <h5 v-if="calibFlag" style="color:lightblue;font-weight:400;">Calibrating...</h5>
              <h2 v-else>{{room.meas && room.meas.iaq ? room.meas.iaq : '-'}}</h2>
          </div>
          <div class="rdg-quarter" style="border-top:2px solid #dce1ec;">
            <v-popover class="quarter-icon" offset="10" trigger="hover" placement="right">
              <img style="width:32px" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/eCO2.png" />
              <small>Carbon<br/>Dioxide</small>
              <template slot="popover">
                  <hover-component :options="hoverOptions('co2')"></hover-component>
              </template>
            </v-popover>
              <h5 v-if="calibFlag" style="color:lightblue;font-weight:400;">Calibrating...</h5>
              <h2 v-else>{{room.meas && room.meas.co2 ? Math.round(room.meas.co2) : '-'}}<span style="font-size:.7em;">ppm</span></h2>
          </div>
      </div>
      <div class="rdg-half-outer" v-if="rdgOne !== 'iaq'">
        <h4 v-html="rO.title">{{rO.title}}</h4>
      </div>
    </div>
    <div class="rdg-sep"></div>
    <div class="rdg-half" v-if="rdgTwo !== 'co2'">
      <div class="rdg-half-outer">
        <img v-if="rdgTwo !== 'dpr'" :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${rT.img}.png`" />
        <img v-if="rdgTwo == 'dpr' && !room.info.coilSensor" src="@/assets/pressureWhite.png" />
        <img v-if="rdgTwo == 'dpr' && room.info.coilSensor" src="https://breezi-pro-assets.s3.eu-west-1.amazonaws.com/coilFlow.png" />
      </div>
      <div class="rdg-half-inner">
        <h1>{{isNaN(rT.val) ? '-' : rT.val}}<span style="font-size:.5em;">{{rT.units}}</span></h1>
      </div>
      <div class="rdg-half-outer">
        <h4 v-html="rT.title">{{rT.title}}</h4>
      </div>
    </div>
    <div class="parent-overlay room-overlay" v-if="parent && parent.info && rdgOne == 'days'">
        <h4>Area Supplied by <span :style="{color: $store.getters.rdgStatus({rdg: 'days', did: parent.did}).color}">{{parent.info.hvacName}}</span></h4>
    </div>
    <div class="rdg-half" v-if="rdgTwo == 'co2'">
      <div class="rdg-half-outer" style="height:50%;width:75%;justify-content:space-around;" :style="{height: '50%', width: '75%', 'flex-direction': room.meas && room.meas.voc <= .734 ? 'row' : 'column', 'align-items': 'center'}">
          <img :style="{height:'55px',width:'40px','margin-right': room.meas && room.meas.voc && room.meas.vAC > 0 && room.meas.voc !== 'no data' && room.meas.voc <= .734 ? '20px' : '0px'}" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/tvocWithText.png"/>
          <h2 v-if="showVOC() && calibFlag !== true"
              :style="{color:vocStatus(room.meas.voc),'line-height': '14px', 'text-align': 'center', 'font-size': '1.25em'}">
              {{room.meas.voc.toString()}}<br/>ppm
          </h2>
          <h3 v-else style="color:lightblue;font-size:.75em;margin-top:0px;">Calibrating...</h3>
      </div>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';
import moment from 'moment';
import cToF from 'celsius-to-fahrenheit';
import Hover from '../hover/Hover';

export default {

  data(){
    return {
      rO: {},
      rT: {}
    }
  },

  props: ['rdgOne', 'rdgTwo', 'dpr', 'calibFlag'],

  computed: {
    room(){
      return this.$store.getters.getActiveRoom();
    },
    clauses(){
      const Room = require('@/lib/langTemplates/RoomTemplate');
      const Card = require('@/lib/langTemplates/CardTemplate');
      const lang = {...Room.clauses, ...Card.clauses};
      let lPref = this.$store.state.lang;
      return Object.keys(lang).reduce((a, i) => {
        a[i] = lang[i][lPref];
        return a;
      }, {});
    }
  },

  components: {
    'hover-component': Hover
  },

  methods: {

    setRdgs(){
      const self = this;
      function displayIfExists(r){
        const room = self[self.parent && self.parent.info && r === 'days' ? 'parent' : 'room'];
        let meas = room.meas && room.meas[r] && parseInt(room.meas[r]) ? (!room.coilSensor || this.$store.state.user.pressure ? room.meas[r] : (room.meas[r] > 0 ? room.meas[r]/249.082 : '-').toFixed(2)) : '-';
        if (self.$store.state.user.metric || r !== 'ttp' || meas === '-') {
          return meas === '-' ? meas : Math.round(meas);
        } else {
          return meas === '-' ? meas : Math.round(cToF(room.meas[r]));
        }
      }
      const lang = this.$store.state.lang;
      switch (this.rdgOne) {
        case 'days':
          this.rO = {
            title: !this.dpr ? (lang === 'en' ? 'Filter<br />Condition' : this.clauses.fCondition) : 'Event<br />Schedule',
            img: !this.dpr ? 'filterOfficial' : 'calendar',
            val: !this.dpr ? displayIfExists('days') : '<span style="font-size:.6em;">Calculating...</span>',
            units: ''
          };
          this.rT = {
            // title: lang === 'en' ? 'Projected<br />Maintenance' : this.clauses.proj,
            title: `${this.dpr ? 'Coil' : 'Delta'}<br />Pressure`,
            img: 'calendar',
            val: this.setPressure(),
              // ? (this.$store.state.user.pressure
              //     ? (this[this.parent && this.parent.info ? 'parent' : 'room'].meas.deltaPressure95Percentile)
              //     : parseFloat(this[this.parent && this.parent.info ? 'parent' : 'room'].meas.deltaPressure95Percentile/249.082).toFixed(2))
              // : (this.$store.state.user.pressure
              //     ? this.room.meas.deltaPressure95Percentile
              //     : parseFloat(this.room.meas.deltaPressure95Percentile/249.082).toFixed(2)),
            // units: 'Δp'
            units: this.$store.state.user.pressure ? 'Pa' : 'iwg'
          };
        break;
        case 'ttp':
          this.rO = {
            title: lang === 'en' ? 'Current<br />Temperature' : this.clauses.curTemp,
            img: 'temp',
            val: displayIfExists('ttp'),
            units: `˚${this.$store.state.user.metric ? 'C' : 'F'}`
          };
          this.rT = {
            title: lang === 'en' ? 'Relative<br />Humidity' : this.clauses.hum,
            img: 'hum',
            val: displayIfExists('hhm'),
            units: '%'
          };
        break;
        case 'iaq':
          this.rO = {
            title: lang === 'en' ? 'Air Quality<br />Index' : this.clauses.aQIndex,
            img: 'iaq',
            val: this.calibFlag ? 'Calibrating...' : displayIfExists('iaq'),
            units: ''
          };
          this.rT = {
            title: lang === 'en' ? 'Carbon<br />Dioxide' : this.clauses.co2,
            img: 'eCO2',
            val: displayIfExists('co2'),
            units: 'ppm'
          }
        break;
      }
    },

    setPressure(coil){
      const ent = this.parent && this.parent.info ? 'parent' : 'room';
      return this.$store.state.user.pressure
        ? this[ent].meas.deltaPressure95Percentile
        : (this[ent].meas.deltaPressure95Percentile/249.082).toFixed(2);
      // const coil = this.room.info.coilSensor;
      //
    },

    setChangeDate(){
      const room = this[this.parent && this.parent.info ? 'parent' : 'room'];
      if (!room.meas || !room.meas.days || room.meas.days === '-') {
        return '-'
      } else {
        let then = Date.now() + (86400000 * room.meas.days);
        return moment(then).format('MMM DD');
      }
    },

    vocStatus(voc){
      if (this.room.meas && this.room.meas.voc && this.room.meas.voc != 'no data' && (!this.room.alerts.voc || (!this.room.alerts.voc.bad && !this.room.alerts.voc.crit))) {
        return '#96fa87';
      } else if (this.room.alerts.voc.bad) {
        return '#f6d857';
      } else if (this.room.alerts.voc.crit) {
        return '#f32b43';
      } else {
        return 'rgb(0, 153, 191)';
      }
    },

    accColor(index, border){
      if (!this.room.meas || !this.room.meas.vAC || (!this.room.meas.voc && this.room.meas.voc !== 0) || this.room.meas.voc > .734 || this.room.meas.voc == 'no data') {
        return border ? '#dce1ec' : 'none';
      } else {
        let color = '';
        switch (this.room.meas.vAC) {
          case 0:
            color = border ? '#dce1ec' : 'none';
          break;
          case 1:
            color = '#f32b43';
          break;
          case 2:
            color = '#f6d857';
          break;
          case 3:
            color = '#96fa87';
          break;
        }
        if (border) {
          return index + 1 <= this.room.meas.vAC ? color : '#dce1ec';
        } else {
          return index + 1 <= this.room.meas.vAC ? color : 'none';
        }
      }
    },

    hoverOptions(rdg){
      let options = {type: 'media'};
      switch (rdg) {
        case 'iaq':
          options.src = 'IAQPlacard';
        break;
        case 'co2':
          options.src = 'CO2ePlacard';
        break;
        case 'voc':
          options.src = 'vocPlacard';
        break;
      }
      return options;
    },

    showVOC(){
      let show = false;
      if (this.room.meas) {
        if (!this.room.meas.voc) {
          try {
            if (this.room.meas.voc.toString() === '0') {
              show = true;
            }
          } catch(err) {
            show = false;
          }
        } else {
          show = this.room.meas.vAC > 0 && this.room.meas.voc !== 'no data' && this.room.meas.voc <= .734;
        }
      }
      return show;
    }

  },

  mounted(){
    console.log({CALIB_FLAG: this.calibFlag})
    if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
    this.setRdgs();
  },

  watch: {
    '$store.state.user.metric': function(newData, oldData){
      this.setRdgs();
    },
    '$store.state.user.pressure': function(newData, oldData){
      this.setRdgs();
    }
  }

}

</script>

<style>

.rdg-outer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.rdg-half {
  width: 48%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rdg-half-outer {
  width: 100%;
  height: 19%;
  display: flex;
  justify-content: flex-start;
}

.rdg-half-outer img {
  height: 100%;
  margin-left: 3%;
  margin-top: 3px;
}

.rdg-half-outer h4 {
  width: 100%;
  text-align: center;
  font-size: .8em;
  margin: 0px;
}

.rdg-half-inner {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rdg-half-inner h1, .rdg-half-inner h6 {
  margin: 2px;
}

.rdg-half-inner h6 {
  height: 17.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: lightblue; */
  border-top: 1px solid #dce1ec;
  padding-top: 4px;
  text-align: center;
}

.cal-img {
  height: 14px;
  margin-right: 3px;
  margin-bottom: 3px;
}

.room-overlay {
  justify-content: center;
  align-items: flex-end;
}

.room-overlay h4 {
  width: 90%;
  text-align: center;
}

.rdg-quarter {
  width: 95%;
  height: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.quarter-icon {
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.rdg-quarter img {
  width: 35px;
  margin-left: 2px;
  border-bottom: 1px solid #dce1ec;
  padding-bottom: 5px;
}

.quarter-icon small {
  text-align: center;
  font-size: .65em;
  padding-top: 3px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdg-quarter h2{
  margin-left: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/room/Rdg.vue